import { MessageCircle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function WhatsAppFab() {
  const { lang } = useLang();
  const msg = lang === "pt"
    ? "Olá! Tenho interesse em reservar a Villa d'Avó Dalva."
    : "Hello! I'm interested in booking Villa d'Avó Dalva.";

  return (
    <a
      href={`https://wa.me/351910565133?text=${encodeURIComponent(msg)}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-20 right-4 md:right-6 z-40 group flex items-center gap-3 bg-[#25D366] text-white py-3 pl-3 pr-5 rounded-full shadow-lg hover:shadow-2xl hover:scale-105 transition-all duration-300"
      aria-label="Contact via WhatsApp"
    >
      <MessageCircle size={20} strokeWidth={2} />
      <span className="text-xs uppercase tracking-[0.15em] font-medium hidden sm:inline">WhatsApp</span>
    </a>
  );
}
